import React, { useState, useImperativeHandle, forwardRef } from 'react'
import { TextArea } from 'components'
import { Modal, Button } from 'react-bootstrap'
import * as Notifications from 'modules/Notifications'

const ConfirmationModal = forwardRef((props, ref) => {
	const initialState = () => {
		return {
			visible: false,
			title: null,
			onYes: null,
			onNo: null,
			displayComment: true,
			message: null,
			comment: ""
		}
	};

	const [state, setState] = useState(initialState());

	// API
	useImperativeHandle(ref, () => ({
		open: (params) => {
			setState(ps => ({
				...ps,
				...params,
				visible: true
			}));
		}
	}));

	const yes = () => {
		if (state.displayComment && !state.comment) {
			Notifications.error("Ingrese un comentario");
			return;
		}

		state.onYes?.(state.comment);

		setState(initialState);
	}

	const no = () => {
		state.onNo?.();

		setState(initialState);
	}

	return (
		<React.Fragment>
			<Modal
				show={state.visible}
				onHide={no}
				backdrop="static">
				<Modal.Header>
					<Modal.Title>{state.title}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div dangerouslySetInnerHTML={{ __html: state.message }} />
					{state.displayComment &&
						<TextArea
							label="Comentario"
							value={state.comment}
							onChange={(value) => setState(ps => ({ ...ps, comment: value }))}
							placeholder="Ingrese un comentario" />}
				</Modal.Body>
				<Modal.Footer>
					<Button variant="link" onClick={no} autoFocus>Cancelar</Button>
					<Button variant="primary" onClick={yes}>Confirmar</Button>
				</Modal.Footer>
			</Modal>
		</React.Fragment>
	)
})

export default ConfirmationModal;